/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG, VIEW_AUTHORITY} from '../../../../../common/constants';
import {StateService} from '../../../../../core/state/state.service';
import {WhiteSpaceInputValidator} from '../../../../../core/validators/white-space-input-validator';
import {IndustryScenario} from '../../../../../models/industry-scenario-dto.model';
import {PropulsionScenario} from '../../../../../models/propulsion-scenario-dto-model';
import {PropulsionScenarioService} from '../../../../../services/propulsion-scenario-service';

@Component({
    selector: 'app-edit-propulsion-scenario-popup',
    templateUrl: './edit-propulsion-scenario-popup.component.html',
    styleUrls: ['./edit-propulsion-scenario-popup.component.scss'],
    standalone: false
})
export class EditPropulsionScenarioPopupComponent implements OnInit {

  dataSource: MatTableDataSource<IndustryScenario> = new MatTableDataSource(null);
  showSpinner = false;

  propulsionScenarioForm: FormGroup;
  propulsionScenario: PropulsionScenario;
  isAdmin: boolean;
  gmid: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropulsionScenario,
    public snackbar: FabMessageService,
    public dialogRef: MatDialogRef<any>,
    private readonly propulsionScenarioService: PropulsionScenarioService,
    private readonly userService: StateService) {
  }

  /**
   * Load the scenario name and scenario assumption for the edit popup
   * Make propulsionScenarioForm with whitespace check validation
   */
  ngOnInit(): void {
    this.isAdmin = this.userService.hasAuthority(VIEW_AUTHORITY.centralOfficeAdminAuthority);
    this.gmid = this.userService.getUserGmid();
    this.propulsionScenario = this.data;
    this.propulsionScenarioForm = new FormGroup({
      updatedPropulsionScenarioName: new FormControl(this.propulsionScenario.propulsionScenarioName, [Validators.required,
        WhiteSpaceInputValidator.noWhitespaceValidator]),
      updatedPropulsionScenarioAssumption: new FormControl(this.propulsionScenario.propulsionScenarioAssumption,
        [Validators.required,
          WhiteSpaceInputValidator.noWhitespaceValidator]),
      updatedIsDeleteLocked: new FormControl(this.propulsionScenario.isDeleteLocked,
        [Validators.required]),
      updatedIsEditLocked: new FormControl(this.propulsionScenario.isEditLocked,
        [Validators.required]),
      updatedIsHiddenLocked: new FormControl(this.propulsionScenario.isHidden, [Validators.required])
    });
  }

  /**
   * Saves all the updated values to propulsionScenario. Calls updatePropulsionScenario from service
   * with the updated propulsionScenario
   */
  onSubmit(): void {
    this.propulsionScenario.propulsionScenarioName = this.propulsionScenarioForm
    .get('updatedPropulsionScenarioName').value;
    this.propulsionScenario.propulsionScenarioAssumption = this.propulsionScenarioForm
    .get('updatedPropulsionScenarioAssumption').value;
    this.propulsionScenario.isDeleteLocked = this.propulsionScenarioForm.get('updatedIsDeleteLocked').value;
    this.propulsionScenario.isEditLocked = this.propulsionScenarioForm.get('updatedIsEditLocked').value;
    this.propulsionScenario.isHidden = this.propulsionScenarioForm.get('updatedIsHiddenLocked').value;
    this.propulsionScenario.createdById = this.gmid;
    this.propulsionScenarioService.updatePropulsionScenario(this.propulsionScenario).subscribe({
      error: (error) => {
        this.errorHandle(error);
      },
      complete: () => {
        this.snackbar.displaySuccess('Successfully updated propulsion scenario', DISMISS_MSG);
        this.onCancel();
      }
    });
  }

  /**
   * On cancel close the dialog
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * display message on error.
   * @param error custom error message.
   */
  errorHandle(error: string): void {
    this.showSpinner = false;
    this.snackbar.displayError(error, DISMISS_MSG);
  }


}
